import { ThemeMode } from '@modules/theme/constants';
import { lighten, useTheme } from '@mui/system';

interface EmptyDashboardBarIllustrationProps {
  isColored?: boolean;
}

export const EmptyDashboardBarIllustration = ({
  isColored = false,
}: EmptyDashboardBarIllustrationProps) => {
  const theme = useTheme();
  const isLightTheme = theme.palette.mode === ThemeMode.LIGHT;

  const barFill = isLightTheme ? '#A9A9A9' : '#23222E';
  const headerFill = isLightTheme ? '#C2C2C2' : '#2c2b37';
  const bodyFill = isLightTheme ? '#D5D5D5' : '#33323d';
  const strokeFill = lighten(theme.palette.background.paper, 0.3);

  return (
    <svg
      width="143"
      height="108"
      viewBox="0 0 315 239"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="315"
        height="238.636"
        rx="9.54545"
        fill={bodyFill}
        stroke={strokeFill}
        strokeWidth="2"
      />
      <rect
        x="38.1816"
        y="66.8184"
        width="237.443"
        height="27.4432"
        rx="2.38636"
        fill={isColored ? '#673ab7' : barFill}
      />
      <rect
        x="38.1816"
        y="102.614"
        width="187.316"
        height="27.4432"
        rx="2.38636"
        fill={isColored ? '#049be5' : barFill}
      />
      <rect
        x="38.1816"
        y="138.41"
        width="151.7"
        height="27.4432"
        rx="2.38636"
        fill={isColored ? '#e65000' : barFill}
      />
      <rect
        x="38.1816"
        y="174.205"
        width="100.254"
        height="27.4432"
        rx="2.38636"
        fill={isColored ? '#fbc02d' : barFill}
      />
      <path
        d="M0 9.54545C0 4.27364 4.27365 0 9.54545 0H305.455C310.726 0 315 4.27365 315 9.54545V36.9886H0V9.54545Z"
        fill={headerFill}
        stroke={strokeFill}
        strokeWidth="2"
      />
    </svg>
  );
};
